export class FileModel {
  public id: number | null = null;
  public file: File;
}
